// Mock data for TNT Legacy Property Services
// NOTE: This is mock/static content used for the frontend-only build.

export const company = {
  name: "TNT Legacy Property Services",
  phone: "727-365-7729",
  phoneHref: "tel:7273657729",
  email: "TNTLP.FL@GMAIL.COM",
  emailHref: "mailto:TNTLP.FL@GMAIL.COM",
  location: "Pinellas County, FL",
  tagline: "Keeping Your Property Looking Its Best",
  subTagline: "More than a company... it's a family legacy.",
  values: ["Family", "Hard Work", "Trust", "Excellence"],
  pills: ["Pools", "Lawns", "Repairs", "Reliability"],
  footerValues: ["Quality", "Integrity", "Family", "Results"],
};

export const heroImage =
  "https://images.unsplash.com/photo-1723411946080-1c8d595ea899?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxwb29sJTIwcGFsbSUyMHRyZWVzfGVufDB8fHx8MTc4OTAwMTMzMnww&ixlib=rb-4.1.0&q=85";

export const services = [
  {
    id: "pools",
    icon: "waves",
    title: "Pool",
    accent: "Services",
    image:
      "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBwb29sfGVufDB8fHx8MTc4OTAwMTMyMXww&ixlib=rb-4.1.0&q=85",
    items: [
      "Routine Cleaning & Maintenance",
      "Filter & Equipment Checks",
      "Chemical Balancing",
      "Green Pool Recovery",
      "Repairs & Equipment Replacement",
    ],
    slogan: "Crystal Clear. Always.",
  },
  {
    id: "lawns",
    icon: "sprout",
    title: "Lawn",
    accent: "Services",
    image:
      "https://images.unsplash.com/photo-1734303023491-db8037a21f09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxsYXduJTIwbGFuZHNjYXBpbmd8ZW58MHx8fHwxNzg5MDAxMzU3fDA&ixlib=rb-4.1.0&q=85",
    items: [
      "Weekly & Bi-Weekly Mowing",
      "Edging & Trimming",
      "Hedge & Bush Care",
      "Weed Control",
      "Clean Ups & Seasonal Services",
    ],
    slogan: "Curb Appeal That Lasts.",
  },
  {
    id: "repairs",
    icon: "wrench",
    title: "Repair",
    accent: "Services",
    image:
      "https://images.unsplash.com/photo-1590635023142-73c3d34f2805?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHx3b3JrZXIlMjBkcmlsbHxlbnwwfHx8fDE3ODkwMDEzNzF8MA&ixlib=rb-4.1.0&q=85",
    items: [
      "General Handyman Work",
      "Plumbing & Electrical",
      "Drywall, Painting & Flooring",
      "Lighting & Fixture Installation",
      "Preventative Maintenance",
    ],
    slogan: "From Quick Fixes to Bigger Projects.",
  },
];

export const trustFeatures = [
  { icon: "shield-check", label: "Reliable Service" },
  { icon: "clock", label: "Fast Response" },
  { icon: "users", label: "Property Manager Focused" },
  { icon: "map-pin", label: "Pinellas County & Surrounding Areas" },
  { icon: "handshake", label: "A Team You Can Trust" },
];

export const partnershipLines = [
  "Well-Maintained Properties.",
  "Happier Tenants.",
  "Stronger Partnerships.",
];

export const testimonials = [
  {
    name: "Melissa Grant",
    role: "Homeowner",
    location: "St. Petersburg, FL",
    rating: 5,
    text: "Our pool water had gotten cloudy and the TNT Legacy team had it crystal clear again in no time. Upfront pricing and they showed up right on schedule. We won't use anyone else.",
  },
  {
    name: "David Alvarez",
    role: "Property Manager",
    location: "Clearwater, FL",
    rating: 5,
    text: "I manage several rentals and the TNT Legacy crew keeps every lawn looking sharp. Fast to respond, easy to reach, and my tenants have never been happier.",
  },
  {
    name: "Karen Whitfield",
    role: "Homeowner",
    location: "Largo, FL",
    rating: 5,
    text: "From a leaky faucet to repainting our lanai, Tyler handled it all. Honest, reliable, and genuinely cares about doing the job right. Feels like working with family.",
  },
  {
    name: "Robert Chen",
    role: "Homeowner",
    location: "Dunedin, FL",
    rating: 5,
    text: "Weekly pool service has been flawless. The team is thorough with the chemical balancing and always leaves the equipment running perfectly. Highly recommend TNT Legacy.",
  },
  {
    name: "Amanda Rivera",
    role: "Property Manager",
    location: "Seminole, FL",
    rating: 5,
    text: "Tyler is my go-to for repairs and landscaping across my Pinellas properties. Quality work, fair prices, and a team I can actually trust to get it done.",
  },
  {
    name: "James Patterson",
    role: "Homeowner",
    location: "Pinellas Park, FL",
    rating: 5,
    text: "Our yard has never looked better. The TNT Legacy team handles the mowing, edging, and hedges like pros. Great communication and truly dependable every single time.",
  },
];
